import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Tr,
  Input,
  InputGroup,
  InputRightAddon,
} from "@chakra-ui/react";
import React from "react";
import FormCheckBox from "../../formcontrol/checkbox";
import FormSelect from "../../formcontrol/select";
import { BsCurrencyDollar } from "react-icons/bs";

function ExtraServiceTable() {
  return (
    <Table borderWidth={"1px"}>
      <Tbody>
        <Tr>
          <Td colSpan={3} display={"flex"} gap={4}>
            {" "}
            <FormCheckBox />{" "}
            <Text fontWeight={"bold"} fontSize={"20px"} color="#c5c5c5">
              Extra Fast Delivery
            </Text>
          </Td>
        </Tr>
        <Tr
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={{ base: "column", lg: "row" }}
        >
          <Td
            borderRightWidth={"1px"}
            w={"full"}
            display={"flex"}
            h={"full"}
            flexDirection={"column"}
            justifyContent={"space-between"}
            bgColor="#F4F4F4"
          >
            <Box w={"full"} py={2}>
              <Text fontWeight={"bold"}>Basic</Text>
            </Box>
            <Box w={"full"} py={2}>
              <Flex justifyContent={"space-between"} alignItems={"center"}>
                <Text>I'll deliver in</Text>
                <FormSelect
                  placeholder={"Select"}
                  border={"none"}
                  bg={"rgba(0,141,219,0.11)"}
                  w={"50%"}
                />
              </Flex>
            </Box>
            <Box w={"full"} py={2}>
              <Flex justifyContent={"space-between"} alignItems={"center"}>
                <Text>For an extra</Text>
                <InputGroup w={"50%"} bg={"rgba(0,141,219,0.11)"}>
                  <Input defaultValue={0} type={"number"} border={"none"} />
                  <InputRightAddon bg={"rgba(0,141,219,0.11)"}>
                    <BsCurrencyDollar />
                  </InputRightAddon>
                </InputGroup>
              </Flex>
            </Box>
          </Td>
          <Td
            borderRightWidth={"1px"}
            w={"full"}
            display={"flex"}
            h={"full"}
            flexDirection={"column"}
            justifyContent={"space-between"}
            bgColor="#F4F4F4"
          >
            <Box w={"full"} py={2}>
              <Text fontWeight={"bold"}>Standard</Text>
            </Box>
            <Box w={"full"} py={2}>
              <Flex justifyContent={"space-between"} alignItems={"center"}>
                <Text>I'll deliver in</Text>
                <FormSelect
                  placeholder={"Select"}
                  border={"none"}
                  bg={"rgba(0,141,219,0.11)"}
                  w={"50%"}
                />
              </Flex>
            </Box>
            <Box w={"full"} py={2}>
              <Flex justifyContent={"space-between"} alignItems={"center"}>
                <Text>For an extra</Text>
                <InputGroup w={"50%"} bg={"rgba(0,141,219,0.11)"}>
                  <Input defaultValue={0} type={"number"} border={"none"} />
                  <InputRightAddon bg={"rgba(0,141,219,0.11)"}>
                    <BsCurrencyDollar />
                  </InputRightAddon>
                </InputGroup>
              </Flex>
            </Box>
          </Td>
          <Td
            borderRightWidth={"1px"}
            w={"full"}
            display={"flex"}
            h={"full"}
            flexDirection={"column"}
            justifyContent={"space-between"}
            bgColor="#F4F4F4"
          >
            <Box w={"full"} py={2}>
              <Text fontWeight={"bold"}>Premium</Text>
            </Box>
            <Box w={"full"} py={2}>
              <Flex justifyContent={"space-between"} alignItems={"center"}>
                <Text>I'll deliver in</Text>
                <FormSelect
                  placeholder={"Select"}
                  border={"none"}
                  bg={"rgba(0,141,219,0.11)"}
                  w={"50%"}
                />
              </Flex>
            </Box>
            <Box w={"full"} py={2}>
              <Flex justifyContent={"space-between"} alignItems={"center"}>
                <Text>For an extra</Text>
                <InputGroup w={"50%"} bg={"rgba(0,141,219,0.11)"}>
                  <Input defaultValue={0} type={"number"} border={"none"} />
                  <InputRightAddon bg={"rgba(0,141,219,0.11)"}>
                    <BsCurrencyDollar />
                  </InputRightAddon>
                </InputGroup>
              </Flex>
            </Box>
          </Td>
        </Tr>
      </Tbody>
    </Table>
  );
}

export default ExtraServiceTable;
